import type { SupervisorAuditedPrecision } from '@avisoma/shared';
import { Badge } from '../../catalyst/badge';
import { auditedLabel, auditedTitle, auditWarning } from './correctionsGrouping';

const WARNING_TITLE =
  'Audited proposal precision is below 80 % on 20 or more labels. Decide whether to retire the check, re-grain it, or keep it.';

/** Check-group header chip from human audit labels (phase 5), with a warning badge; nothing while the version has no label. */
export function AuditedChip({ audited }: { audited: SupervisorAuditedPrecision | undefined }) {
  if (!audited || audited.labels === 0) return null;
  return (
    <span className="inline-flex items-center gap-1.5">
      <Badge color="sky" title={auditedTitle(audited)}>
        {auditedLabel(audited)}
      </Badge>
      {auditWarning(audited) && (
        <Badge color="red" title={WARNING_TITLE}>
          below 80 %
        </Badge>
      )}
    </span>
  );
}
